const equipmentBadgeStatus = {
  inactive: 'Inactivo',
  maintenance: 'Mantenimiento',
  valid: 'Valido',
  invalid: 'Invalido',
  validWithOpenedActions: 'Valido*',
};

export default equipmentBadgeStatus;